import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Table from "./Table";

import baseUrl, {
  authentication,
  deductPoints,
  updateFirstName,
  updateLastName,
  updatePoints,
  bankAverage,
  addBankAverage,
  roundAverage,
  isOhrHachaim,
  setClass,
  showWorkPoints,
  useModelPerDay
} from "../Utils";

class Bank extends React.Component {
  reset = () => {
    this.setState(
      {
        studentData: [],
        date: "",
        formattedDate: "",
      },
      setClass(this)
    );
  };
  boldPoints = true;
  boldWork =false;
  constructor(props) {
    super(props);
    if (showWorkPoints) {
      this.boldPoints = false;
      this.boldWork = true;
    }
    // this.getStudents()
    this.state = {
      studentData: [],
      newSubcategoryOpen: false,
      studentColumns: [
        {
          dataField: "first_name",
          text: "First Name",
          sort: true,
          row: 1,
        },
        {
          dataField: "last_name",
          text: "Last Name",
          sort: true,
          row: 1,
        },
        {
          dataField: "bank_account_number",
          text: "Bank account number",
          sort: true,
          editable: false,
        },
        {
          dataField: "points",
          text: isOhrHachaim ? "YEAR TO DATE" : "Points",
          sort: true,
          row: 1,
          editable: true,
          formatter: (cell, row) => {
            if (this.boldPoints) {
              return this.boldedFormat(cell, row)
            } else {
              return cell;
            }
          }
        },
        {
          dataField: "marks",
          text: showWorkPoints ? "Total Marks" : "Marks",
          sort: true,
          editable: false,
        }
      ]
    };

    if (showWorkPoints) {
      this.state.studentColumns.push(
        {
          dataField: "behavior_marks",
          text: "Behavior",
          sort: true,
          editable: false,
        },
        {
          dataField: "work",
          text: "Work",
          sort: true,
          editable: false,
        },
        {
          dataField: "late",
          text: "Late",
          sort: true,
          editable: false,
        });
    }

    this.state.studentColumns.push(
        {
          dataField: "tests",
          text: "Missing Tests",
          sort: true,
          editable: false,
          formatter: (cell, row) => {
            if (this.boldWork) {
              return this.boldedFormat(cell, row)
            } else {
              return cell;
            }
          }
        },
        {
          dataField: "retake",
          text: "Missing Retakes",
          sort: true,
          editable: false,
          formatter: (cell, row) => {
            if (this.boldWork) {
              return this.boldedFormat(cell, row)
            } else {
              return cell;
            }
          }
        },
        {
          dataField: "grade",
          text: "Grade",
          sort: true,
          editable: false,
        },
        {
          dataField: "class",
          text: "Class",
          sort: true,
          editable: false,
        },
        {
          dataField: useModelPerDay ? "model" : "percentOfModel",
          text: useModelPerDay ? "Behavior %" : "%",
          sort: true,
          editable: false,
        });

    if (bankAverage) {
      this.state.studentColumns.push({
        dataField: "average",
        text: "Test Average",
        sort: true,
        editable: false,
        formatter: (cell, row) => {
          return roundAverage(cell);
        },
      });
    }

    if (useModelPerDay) {
      this.state.studentColumns.push(
        {
          dataField: 'df1',
          isDummyField: true,
          text: 'Total Average',
          formatter: (cellContent, row) => {
            return (
              ((row.average != "NA") ? 
                (isNaN(row.average) || (!(row.average)) || (!row.model)) ? "NA" :
              roundAverage((row.average + row.model) /2) : row.model)
            );
          },
          headerFormatter:  this.addCloseColumn
        }
      );
    }
    setClass(this);
  }
  
  validate = () => {
    if (this.state.formattedDate == "") {
      alert("Please Select A Date.");
      return false;
    }
    return true;
  };
  submit = () => {
    if (this.validate()) {
      let students = {
        students: this.state.studentData,
        date: this.state.formattedDate,
      };
      students = JSON.stringify(students);

      let formData = new FormData();
      formData.append("data", students);
      fetch(`${baseUrl}/redeem-rewards`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: authentication,
        },
      })
        .then((response) => response.text())

        .then((text) => {
          students = "";

          if (text == "successful") {
            this.reset();
          } else {
            alert("error" + text);
          }
        });
    }
  };

  boldedFormat = (cell, row) => { 
    if (row.tests != "" || row.retake != "" || row.marks < -4) {
      return (
        <span
          style={{
            width: "100%",
            height: "100%",
            background: "black",
            padding: "0px",
          }}
        >
          <strong style={{ color: "white" }}>{cell} </strong>
        </span>
      );
        }
        return <span>{cell}</span>
    }

  getStudents = () => {
    var url = new URL("http://ohrhatorah.appsenses.com/students.php");
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        // console.log(res)
        res.forEach((a) => {
          a.id = parseInt(a.id);
          a.points = parseInt(a.points);
        });
        this.setState({ subcategories: res });
      });

    // this.setState({isSubcategoryDialogOpen:true})
  };

  render() {
    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item href="Home">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Rewards</Breadcrumb.Item>
          <Breadcrumb.Item active>Bank</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: "15px" }}>
          <div
            className="row"
            style={{ textAlign: "center", paddingBottom: "15px" }}
          >
            <div
              className="col-sm-12 col-lg-6"
              style={{ paddingTop: "10px" }}
            ></div>

            <div
              className="col-sm-12 col-lg-6"
              style={{ paddingRight: "30px", paddingBottom: "10px" }}
            >
              {/* <Button style={{float:"right"}} onClick={()=>{this.submit()}}>
                                    Save
                                </Button>*/}
            </div>
          </div>

          {this.state.studentData != undefined ? (
            <Table
              paginationDownward={true}
              delete={false}
              editFunc={(oldValue, newValue, row, column) => {
                {
                  if (oldValue != newValue) {
                    if (column.dataField == "points") {
                      let points = newValue - oldValue;
                      deductPoints(row.id, points);
                    }
                    if (column.dataField == "first_name") {
                      updateFirstName(row.id, newValue);
                    }
                    if (column.dataField == "last_name") {
                      updateLastName(row.id, newValue);
                    }
                  }
                }
              }}
              columns={this.state.studentColumns}
              data={this.state.studentData}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default Bank;
